/**
 * The price a customer actually pays for a product option, for analytics.
 *
 * A product option carries both `price` (list/RRP) and `salePrice` (current
 * discounted price). The storefront shows `salePrice` when it's a valid
 * discount; analytics must report the same number, otherwise GA4 value/revenue
 * is inflated on sale items (e.g. a £350 list / £175 sale item reporting £350).
 *
 * Mirrors the "valid sale" rule used in the product page and option labels:
 *   salePrice != null && salePrice > 0 && salePrice < price
 */
export type PricedOption = {
  price?: number | null
  salePrice?: number | null
}

export function effectiveOptionPrice(
  option: PricedOption | null | undefined
): number | undefined {
  if (!option) return undefined
  const price = typeof option.price === 'number' ? option.price : undefined
  const salePrice =
    typeof option.salePrice === 'number' ? option.salePrice : undefined

  if (salePrice != null && salePrice > 0 && price != null && salePrice < price) {
    return salePrice
  }
  return price
}
